document.addEventListener("DOMContentLoaded", () => {

  const popup = document.querySelector(".video-popup");
  if (!popup) return;

  const popupVideo = popup.querySelector(".popup-left video");

  const productImage = popup.querySelector(".popup-product-image");
  const productTitle = popup.querySelector(".popup-product-title");
  const productPrice = popup.querySelector(".popup-product-price");
  const productDesc  = popup.querySelector(".popup-product-description");
  const productLink  = popup.querySelector(".product-link");

  const allVideos = document.querySelectorAll(".video-wrapper video");

  /* =========================
     AUTOPLAY / PLAY BUTTON
  ========================== */

  allVideos.forEach(video => {

    const wrapper = video.closest(".video-wrapper");
    const btn = wrapper.querySelector(".play-btn");

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    // Autoplay ON
    if (!btn) {
      video.play().catch(() => {});
      return;
    }

    // Autoplay OFF
    video.pause();
    btn.style.display = "flex";

    btn.addEventListener("click", (e) => {

      e.stopPropagation();

      video.play().catch(() => {});
      btn.style.display = "none";

    });

    video.addEventListener("click", (e) => {

      e.stopPropagation();

      if (video.paused) {

        video.play().catch(() => {});
        btn.style.display = "none";

      } else {

        video.pause();
        btn.style.display = "flex";

      }

    });

    video.addEventListener("pause", () => {
      btn.style.display = "flex";
    });

    video.addEventListener("play", () => {
      btn.style.display = "none";
    });

    video.addEventListener("ended", () => {
      btn.style.display = "flex";
    });

  });

  /* =========================
     REELS AUTOPLAY
  ========================== */

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      const video = entry.target;
      const wrapper = video.closest(".video-wrapper");
      const btn = wrapper.querySelector(".play-btn");

      if (btn) return; // autoplay OFF

      if (entry.isIntersecting) {

        video.play().catch(() => {});

      } else {

        video.pause();

      }

    });

  }, {
    threshold: 0.6
  });

  allVideos.forEach(video => observer.observe(video));

  /* =========================
     POPUP
  ========================== */

  document.addEventListener("click", (e) => {

    const card = e.target.closest(".video-card");
    if (!card) return;

    if (e.target.closest(".play-btn")) return;

    const videoEl = card.querySelector("video");
    const mp4 = videoEl?.dataset.mp4;

    if (!mp4) return;

    allVideos.forEach(v => v.pause());

    popupVideo.pause();
    popupVideo.src = mp4;

    popupVideo.muted = true;
    popupVideo.defaultMuted = true;
    popupVideo.setAttribute("muted", "");
    popupVideo.setAttribute("playsinline", "");

    popupVideo.controls = true;
    popupVideo.load();
    popupVideo.play().catch(() => {});

    productImage.src = card.dataset.productImage || "";
    productTitle.textContent = card.dataset.productTitle || "";
    productPrice.textContent = card.dataset.productPrice || "";
    productDesc.textContent = card.dataset.productDescription || "";
    productLink.href = card.dataset.productUrl || "#";

    popup.removeAttribute("hidden");

  });

  /* =========================
     CLOSE POPUP
  ========================== */

  popup.querySelector(".close-popup")?.addEventListener("click", () => {

    popup.setAttribute("hidden", true);

    popupVideo.pause();
    popupVideo.src = "";

    allVideos.forEach(video => {

      const wrapper = video.closest(".video-wrapper");
      const btn = wrapper.querySelector(".play-btn");

      if (!btn) {
        video.play().catch(() => {});
      }

    });

  });

});